<template>
	<b-modal id="eventTicketCourtesyFormnModal" :title="title" no-close-on-backdrop hide-footer>
		<Loader :show="loading" type="inline" />

		<FormulateForm v-if="!loading" v-model="form" ref="form" @submit="save">
			<!-- <p class="text-secondary">
				Envía tickets de cortesía a un usuario<br />
			</p> -->

			<div class="label">Datos de receptor</div>
			<div class="row row-xs">
				<div class="col-6">
					<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />
				</div>
				<div class="col-6">
					<FormulateInput label="Apellido" name="lastname" validation-name="Apellido" validation="required" />
				</div>
			</div>

			<div class="mt-2">
				<FormulateInput label="Email" type="email" name="email" validation-name="Email" validation="required" />
			</div>

			<div class="label mt-3">Ticket de cortesía</div>
			<div class="row row-xs">
				<div class="col-6 ">
					<FormulateInput
						label="Tipo de ticket"
						name="ticketTypeId"
						type="selectSearch"
						:options="eventTicketTypes"
						validation-name="Tipo de ticket"
						validation="required"
						optionValue="id"
						optionText="name"
						:help="`${maxQuantity ? 'Tickets disponibles: ' + maxQuantity : ''}`"
					/>
				</div>
				<div class="col-6 ">
					<FormulateInput
						type="number"
						label="Cantidad"
						name="quantity"
						validation-name="Cantidad de tickets"
						:validation="`required|max:${maxQuantity}`"
						:max="maxQuantity"
					/>
				</div>
			</div>

			<FormulateInput
				type="date"
				label="Fecha y hora límite de ingreso"
				name="validAt"
				:displayFormat="'DD-MM-YYYY HH:mm'"
				validation-name="Fecha límite de acceso al evento"
				:validation="`before:${$moment(this.validAtMax).format('YYYY-MM-DD HH:mm')}`"
				class="flex-grow-1 mb-4 mt-3"
				:max="$moment(this.validAtMax).format('YYYY-MM-DD HH:mm')"
			/>

			<hr />

			<div class="d-flex justify-content-between mt-4">
				<FormulateInput type="button" data-ghost @click="close">Cancelar</FormulateInput>
				<FormulateInput type="button" disabled v-if="saving">Enviar <span class="loader"/></FormulateInput>
				<FormulateInput type="submit" label="Guardar" v-else />
			</div>
		</FormulateForm>
	</b-modal>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "EventTicketCourtesyForm",
	props: {
		eventId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			loading: true,
			saving: false,
			title: "Enviar tickets de cortesía",
			action: "create",
			form: {
				name: null,
				email: null,
				ticketTypeId: null,
				quantity: 1,
				validAt: null
			},
			eventTicketTypes: [],
			event: null,
			validAtMax: this.$moment().toDate()
		}
	},

	computed: {
		maxQuantity: function() {
			return (
				(this.form.ticketTypeId &&
					this.eventTicketTypes.find((t) => t.id == this.form.ticketTypeId).ticketsAvailable) ||
				0
			)
		}
	},

	methods: {
		async open(item) {
			await this.fetchData()
			// this.loading = true
			// if (item) {
			// 	this.title = "Editar grupo de tickets"
			// 	this.action = "update"
			// 	this.eventTicketGroupId = item.id
			// 	this.form = {
			// 		name: item.name,
			// 		minPerOrder: item.minPerOrder,
			// 		maxPerOrder: item.maxPerOrder,
			// 		ticketTypes: item.ticketTypes.map((type) => ({
			// 			id: type.id,
			// 			name: type.name,
			// 			priceUnit: type.priceUnit,
			// 			ticketsLimit: type.ticketsLimit
			// 		})),
			// 		ticketsLimit: item.ticketsLimit,
			// 		validAt: this.$moment(item.validAt).format("YYYY-MM-DD HH:mm:00")
			// 	}
			// } else {
			// 	this.form = {
			// 		name: null,
			// 		minPerOrder: 1,
			// 		maxPerOrder: 10,
			// 		ticketTypes: [
			// 			{
			// 				id: null,
			// 				name: null,
			// 				priceUnit: null,
			// 				ticketsLimit: null
			// 			}
			// 		],
			// 		ticketsLimit: null,
			// 		validAt: null
			// 	}
			// 	if (this.limitDateAt) {
			// 		this.form.validAt = this.$moment(this.limitDateAt).format("YYYY-MM-DD HH:mm:00")
			// 	}
			// }

			this.$bvModal.show("eventTicketCourtesyFormnModal")
			this.loading = false
		},
		close() {
			this.$bvModal.hide("eventTicketCourtesyFormnModal")
			this.form = {
				name: null,
				email: null,
				ticketTypeId: null,
				quantity: 1,
				validAt: null
			}
			this.eventTicketTypes = []
			this.event = null
		},

		async save() {
			if (!this.saving) {
				this.saving = true
				let data = {
					eventId: this.eventId,
					name: this.form.name,
					lastname: this.form.lastname,
					email: this.form.email,
					quantity: parseInt(this.form.quantity),
					ticketTypeId: this.form.ticketTypeId,
					validAt: this.form.validAt
				}
				if (this.action == "create") await this.create(data)
				// if (this.action == "update") await this.update(data)
				this.$emit("updated")
				this.close()

				this.saving = false
			}
		},

		async create(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: TicketCourtesyInput!) {
							ticketCourtesyCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Tickets de cortesía enviados correctamente")
					this.saving = false
					return data.eventTicketGroupCreate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		// async update(data) {
		// 	return this.$apollo
		// 		.mutate({
		// 			mutation: gql`
		// 				mutation($id: ID!, $data: EventTicketGroupInput!) {
		// 					eventTicketGroupUpdate(id: $id, data: $data) {
		// 						id
		// 					}
		// 				}
		// 			`,
		// 			variables: {
		// 				id: this.eventTicketGroupId,
		// 				data
		// 			},
		// 			fetchPolicy: "no-cache"
		// 		})
		// 		.then(({ data }) => {
		// 			this.$toast.success("Tickets editados correctamente")
		// 			return data.eventTicketGroupUpdate
		// 		})
		// 		.catch((err) => {
		// 			this.parseGQLErrors(err)
		// 			this.saving = false
		// 		})
		// },

		fetchData() {
			return this.$apollo
				.query({
					query: gql`
						query($eventId: ID) {
							event(id: $eventId) {
								id
								name
								endAt
							}
							eventTicketTypes(eventId: $eventId) {
								data {
									id
									name
									ticketGroup {
										id
										name
										ticketsAvailable
									}
								}
							}
						}
					`,
					variables: {
						eventId: this.eventId
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.eventTicketTypes = data.eventTicketTypes.data.map((item) => {
						return {
							id: item.id,
							name: item.ticketGroup.name + " - " + item.name,
							ticketsAvailable: item.ticketGroup.ticketsAvailable
						}
					})

					this.event = data.event
					this.validAtMax = this.$moment(this.event.endAt).format("YYYY-MM-DD HH:mm:00")
				})
		}
	}
}
</script>

<style scoped>
.periods .period {
	display: flex;
}
</style>
